export const to_API_URL = (partialPath: string) => staging + partialPath;
export const DEFAULT_HEADERS = {
        "Content-Type": "application/json",
        "Accept": "*/*",
        "Cache-Control":"no-cache",
        "Connection":"keep-alive",
        "Host":"https://api.test.onepush.studio",
}
const staging =  "https://api.test.onepush.studio/";
const mockoon = "http://localhost:3001/"
const local = "http://localhost:8080/"